/* vg-brand-flag.js - kruhova vlajecka zeme vyrobce za nazvem znacky
   Zadani klienta ze 17. 8. 2026.

   PROC JS A NE LIQUID: znacka se vykresluje v bloku "vendor" v sekcich
   sections/main-product.liquid (radek 566), sections/featured-product
   .liquid (563) a sections/product-quick-view.liquid (362). Ty soubory
   maji 129-160 kB a themeFilesUpsert neumi castecnou upravu - jedno
   vlozene slovo znamena prepsat cely soubor. U dekorativniho odznacku
   to neni umerne riziko, proto se vlajecka dopisuje az v prohlizeci.

   PROC INLINE SVG A NE EMOJI: vlajkova emoji Windows nevykresluje
   a misto vlajky by se ukazala pismena "CZ".

   POPISEK JE "Vyrobce: Italie", NE "Vyrobeno v Italii": zeme vyrobce je
   to, co skutecne vime, tvrzeni o puvodu zbozi bychom u kazde polozky
   nedolozili.

   SENCOR ZATIM VLAJKU NEMA: zakaznik uvedl Japonsko, ale znacku dnes
   vlastni a na trh uvadi ceska FAST CR a. s. a vyrabi se v Asii; web
   znacky mluvi o japonskem puvodu jen historicky ("pribeh zacal v roce
   1969"). Vlajka s popiskem "Vyrobce: Japonsko" by bylo tvrzeni o
   puvodu, ktere bychom nedolozili, proto ceka na potvrzeni.

   VZHLED resi assets/vg-custom.css sekce 30 (tridy .vg-flag a
   .vg-flag svg). Tenhle soubor jen vklada markup.

   ---------------------------------------------------------------------
   17. 8. 2026, OPRAVA: NAZEV ZNACKY SE CTE Z HREF, NE Z TEXTU ODKAZU.
   Prvni verze brala nazev z link.textContent a vlajecka se ukazovala jen
   u casti produktu. Duvod: na strance bezi jeste jiny skript motivu,
   ktery radek se znackou po nacteni prepisuje - doplni popisek a prevede
   na velka pismena, takze z "Alfa Classic" se stane "Znacka: ALFA
   CLASSIC". Takovy retezec uz v mape neni a vlajecka se nevlozila; kde
   se nas skript trefil driv, prepis ji zase smazal. Zavod dvou skriptu
   nad tymz textem se vyhrat neda.

   Href je proti tomu stabilni - filtr url_for_vendor vyrobi
   /collections/vendors?q=Alfa%20Classic a zadny skript ho neprepisuje.
   Cte se tedy parametr q; cteni z textu zustava jen jako zaloha pro
   pripad, ze by q chybelo, a odstranuje si pripadny popisek pred
   dvojteckou. */
(function () {
  'use strict';

  /* Ochrana proti dvojimu spusteni - kdyby se soubor nacetl dvakrat,
     bezely by dva observery nad tymz dokumentem. */
  if (window.vgBrandFlagLoaded) return;
  window.vgBrandFlagLoaded = true;

  /* --- Mapa znacka -> zeme -------------------------------------------
     Seznam dodany zakaznikem 17. 8. 2026. Klice jsou uz znormalizovane
     (mala pismena, jednoduche mezery, rovny apostrof) - stejnou upravou
     projde i hodnota z href, viz vgNorm(). Novou znacku staci dopsat
     sem. Znacka mimo mapu vlajecku nedostane, nevykresli se nic. */
  var VG_FLAG_MAP = {
    /* Cesko */
    'alfa classic': 'cz',
    'alfaclassic': 'cz',
    'botanica': 'cz',
    'ella delannoy': 'cz',
    'styl vd': 'cz',
    'espeon': 'cz',
    'alda': 'cz',
    'lari cz': 'cz',
    'simple and pure': 'cz',
    'simpleandpure': 'cz',
    'vittore de conti': 'cz',
    'baopure': 'cz',
    'baopure collection': 'cz',
    'secesse': 'cz',
    'herbal collection': 'cz',
    'herbal': 'cz',
    'nature philosophy': 'cz',
    'betty': 'cz',
    'clanax': 'cz',
    'toal': 'cz',
    /* Trim - prasky a cistice vyrabi Alfa Classic v Cesku,
       potvrzeno zakaznikem 18. 8. 2026. */
    'trim': 'cz',
    /* P&G Profesional - v href je ampersand zakodovany jako %26, takze
       regex na q= ho nerozdeli na dva parametry a klic sedi. */
    'p&g profesional': 'cz',
    'p&g professional': 'cz',
    'p&g profesionál': 'cz',

    /* Italie */
    'interchem': 'it',
    'io': 'it',
    'io splendo': 'it',
    'fiorillo': 'it',
    'argonit': 'it',
    'casachiara': 'it',
    'relevi': 'it',
    'pratic': 'it',
    'pratika': 'it',
    'green emotion': 'it',
    'ecogreen': 'it',
    "l'ecologico": 'it',
    'lecologico': 'it',
    'icefor': 'it',
    'flacer': 'it',
    'scala': 'it',
    'dezipower': 'it',
    'neflek': 'it',
    'pulirapid': 'it',
    'winnis': 'it',
    'bobinetta': 'it',
    'forte professional': 'it',
    'forte profesional': 'it',
    'dermomed': 'it',
    /* FINITO - toaletni papir, italska vyroba; v datech je
       dodavatel psany velkymi pismeny, vgNorm() ho srovna. */
    'finito': 'it',
    /* NEFEL - italska znacka (v CR ji distribuuje Kalvei), doplneno
       4. 11. 2026 na pokyn zakaznika. V datech je psana s diakritikou
       (NEFÉL) a vgNorm() diakritiku neodstranuje, proto je klic
       v mape s ni i bez. */
    'nefél': 'it',
    'nefel': 'it',

    /* Spojene staty */
    'fre-pro': 'us',
    'fre pro': 'us',
    'frepro': 'us',
    'fresh products': 'us',
    'freshproducts': 'us',

    /* Spanelsko - doplneno 17. 8. 2026, tri produkty (zasobniky
       a davkovac FUTURA). */
    'jofel': 'es',

    /* Nemecko - doplneno 17. 8. 2026 na pokyn zakaznika.
       Karcher se pise s prehlaskou; klic je v mape s diakritikou i bez,
       protoze vgNorm() diakritiku neodstranuje a v datech se objevuje
       oboji. Lacoform je znacka nemecke Chemoform AG (Wendlingen am
       Neckar), overeno v obchodnim rejstriku. */
    'ipuro': 'de',
    'i-puro': 'de',
    'kärcher': 'de',
    'karcher': 'de',
    'kaercher': 'de',
    'bref': 'de',
    'lacoform': 'de',
    'vileda': 'de',
    'desclean': 'de',

    /* Finsko */
    'harvia': 'fi',

    /* Nizozemsko - HG International B.V. */
    'hg': 'nl'
  };

  var VG_FLAG_LABEL = {
    cz: 'Česko',
    it: 'Itálie',
    es: 'Španělsko',
    us: 'Spojené státy',
    de: 'Německo',
    fi: 'Finsko',
    nl: 'Nizozemsko',
    /* Japonsko je pripravene, ale zadna znacka se na nej zatim nemapuje
       - viz poznamka o Sencoru v hlavicce souboru. */
    jp: 'Japonsko'
  };

  /* Hvezdy u vlajky USA se nekresli zamerne - v 18 px by z nich byla
     kase, kanton zustava ciste modry. */
  var VG_FLAG_SVG = {
    cz: '<rect width="24" height="12" fill="#fff"/>' +
        '<rect y="12" width="24" height="12" fill="#d7141a"/>' +
        '<path d="M0 0 12 12 0 24Z" fill="#11457e"/>',
    it: '<rect width="8" height="24" fill="#009246"/>' +
        '<rect x="8" width="8" height="24" fill="#fff"/>' +
        '<rect x="16" width="8" height="24" fill="#ce2b37"/>',
    es: '<rect width="24" height="24" fill="#c60b1e"/>' +
        '<rect y="6" width="24" height="12" fill="#ffc400"/>',
    /* Nemecko: cerna, cervena, zlata - tri vodorovne pruhy po 8 px. */
    de: '<rect width="24" height="8" fill="#000"/>' +
        '<rect y="8" width="24" height="8" fill="#dd0000"/>' +
        '<rect y="16" width="24" height="8" fill="#ffce00"/>',
    /* Nizozemsko: cervena, bila, modra. */
    nl: '<rect width="24" height="8" fill="#ae1c28"/>' +
        '<rect y="8" width="24" height="8" fill="#fff"/>' +
        '<rect y="16" width="24" height="8" fill="#21468b"/>',
    /* Finsko: skandinavsky kriz, svisle rameno posunute k zerdi. */
    fi: '<rect width="24" height="24" fill="#fff"/>' +
        '<rect x="7" width="4.5" height="24" fill="#003580"/>' +
        '<rect y="9.75" width="24" height="4.5" fill="#003580"/>',
    /* Japonsko: bily podklad, cerveny kotouc uprostred. */
    jp: '<rect width="24" height="24" fill="#fff"/>' +
        '<circle cx="12" cy="12" r="6.6" fill="#bc002d"/>',
    us: '<rect width="24" height="24" fill="#fff"/>' +
        '<rect y="0" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="3.692" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="7.385" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="11.077" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="14.769" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="18.462" width="24" height="1.846" fill="#b22234"/>' +
        '<rect y="22.154" width="24" height="1.846" fill="#b22234"/>' +
        '<rect width="10" height="9.23" fill="#3c3b6e"/>'
  };

  /* Kotva v DOM: odkaz na vyrobce uvnitr radku se znackou. Filtr ma dve
     casti schvalne - .product__subtitle nese i radek s objemem (ten ale
     zadny odkaz na vyrobce nema) a /collections/vendors je cesta, kterou
     vyrabi filtr url_for_vendor. Substringove porovnani prezije i
     jazykovy prefix v adrese (/cs/collections/vendors...). */
  var VG_FLAG_SELECTOR = '.product__subtitle a[href*="/collections/vendors"]';

  /* Normalizace nazvu znacky. Apostrof se srovnava na rovny, protoze
     l'ecologico byva v datech psane i s typografickym apostrofem (U+2019);
     bez toho by se znacka v mape nenasla. */
  function vgNorm(text) {
    return String(text || '')
      .replace(/[’ʼ´`]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* Hlavni zdroj: parametr q z href. Href je relativni, takze zadne
     new URL() - staci vytahnout q regexem. Plus se dekoduje na mezeru
     rucne, decodeURIComponent to sam nedela. Kdyby bylo procento
     poskozene, decodeURIComponent vyhodi vyjimku a vratime prazdno,
     aby se pouzila zaloha z textu. */
  function vgVendorFromHref(link) {
    var href = link.getAttribute('href') || '';
    var m = href.match(/[?&]q=([^&#]*)/);
    if (!m) return '';
    try {
      return decodeURIComponent(m[1].replace(/\+/g, ' '));
    } catch (e) {
      return '';
    }
  }

  /* Zaloha: text odkazu. Cizi skript motivu do nej pridava popisek
     ("Znacka: ALFA CLASSIC"), proto se bere jen cast za POSLEDNI
     dvojteckou. Kdyz zadna dvojtecka neni, vezme se text cely. */
  function vgVendorFromText(link) {
    var text = link.textContent || '';
    var i = text.lastIndexOf(':');
    return i === -1 ? text : text.slice(i + 1);
  }

  function vgMakeFlag(country) {
    var label = VG_FLAG_LABEL[country];
    var span = document.createElement('span');
    span.className = 'vg-flag';
    span.setAttribute('role', 'img');
    span.setAttribute('title', 'Výrobce: ' + label);
    span.setAttribute('aria-label', 'Výrobce: ' + label);
    span.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      VG_FLAG_SVG[country] + '</svg>';
    return span;
  }

  /* Pojistka proti pretahovane: kdyby cizi skript prepisoval radek
     donekonecna, vkladali bychom vlajecku porad dokola a vytizili
     procesor. Po prekroceni stropu se observer odpoji - vlajecka
     zustane v tom stavu, v jakem prave je, a stranka bezi dal. Bezny
     detail produktu vlozi jednu az dve, strop je tedy hodne vysoko. */
  var VG_FLAG_MAX = 200;
  var vgInserted = 0;
  var vgObserver = null;

  function vgBrandFlags() {
    var links = document.querySelectorAll(VG_FLAG_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      var link = links[i];

      /* Uz tam je? Kontroluje se VYHRADNE nasledujici sourozenec v DOM,
         tedy nic, co by prezilo prepsani rodice. Kdyby se pouzil
         priznak na odkazu nebo seznam hotovych elementu v pameti
         skriptu, po prepisu innerHTML rodice by kontrola tvrdila
         "hotovo", ale vlajecka uz by v dokumentu nebyla. Takhle je
         vzdycky pravda to, co je videt. */
      var next = link.nextElementSibling;
      if (next && next.classList && next.classList.contains('vg-flag')) continue;

      var vendor = vgVendorFromHref(link) || vgVendorFromText(link);
      var country = VG_FLAG_MAP[vgNorm(vendor)];
      if (!country) continue;

      /* Zbytky po prepisu: kdyby v radku zustala vlajecka jinde nez
         hned za odkazem, smazeme ji, at je v radku vzdycky prave jedna. */
      var parent = link.parentNode;
      if (!parent) continue;
      var stale = parent.querySelectorAll('.vg-flag');
      for (var j = 0; j < stale.length; j++) {
        if (stale[j].parentNode) stale[j].parentNode.removeChild(stale[j]);
      }

      parent.insertBefore(vgMakeFlag(country), link.nextSibling);

      if (++vgInserted >= VG_FLAG_MAX && vgObserver) {
        vgObserver.disconnect();
        vgObserver = null;
        return;
      }
    }
  }

  /* MutationObserver, ne posluchace na otevreni nahledu: rychly nahled,
     prepnuti varianty i doporucene produkty dosypava motiv na nekolika
     ruznych mistech a kazde ma vlastni udalost - observer chyti vsechny
     najednou a nemusi se hlidat, jestli motiv nejakou udalost
     neprejmenoval. Stejny vzor uz pouziva snippets/vg-custom.liquid.

     Observer je zaroven to, co vlajecku VRACI, kdyz ji prepis radku
     smaze: prepis je taky mutace, takze nas probudi, kontrola vyse
     najde odkaz bez vlajecky a vlozi ji znovu.

     Bez zacykleni: vlastni vlozeni vlajecky observer probudi, ale druhy
     pruchod uz nic nemeni, takze zadna dalsi mutace nevznikne a smycka
     se zastavi. requestAnimationFrame navic slouci davku zmen do
     jednoho pruchodu. */
  var vgQueued = false;
  function vgRun() {
    if (vgQueued) return;
    vgQueued = true;
    window.requestAnimationFrame(function () {
      vgQueued = false;
      vgBrandFlags();
    });
  }

  document.addEventListener('DOMContentLoaded', vgRun);
  vgObserver = new MutationObserver(vgRun);
  vgObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  vgRun();
})();
